export const TYPE = 'eventNames';
